import React, {useEffect, useState} from "react";
import { Box } from '@mui/material';

export default function SpaCheck() {
  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isSpaApp, setIsSpaApp] = useState(false);
  const [isPwa, setIsPwa] = useState(false);

  useEffect(()=>{
    var _isAndroid = /Android/i.test(navigator.userAgent);
    setIsAndroid(_isAndroid);
    var _isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(_isIOS);
    var _isSpaApp = window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
    setIsSpaApp(_isSpaApp);
    var _isPwa = window.matchMedia('(display-mode: standalone)').matches;
    setIsPwa(_isPwa);

    if(!isPwa && (isIOS || isAndroid)){
    }
  });

  return (
    <Box sx={{ display: 'flex', flexDirection:'column' }}>
    </Box>
  );
}